import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {finalize} from 'rxjs/operators';
import {HttpRequestService} from "./http-request.service";

/**
 * Marca las peticiones de fondo (el contador de mensajes, sus indicadores) para que no saquen el
 * «CARGANDO». Es un HttpContext y no una cabecera: una cabecera nueva viajaría a la API y el CORS
 * de producción, que fija Apache, no la admite.
 */
export const SIN_INDICADOR_CARGA = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

    constructor(private requestService: HttpRequestService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.context.get(SIN_INDICADOR_CARGA)) {
            return next.handle(req);
        }

        // Aumenta el contador cuando se inicia una solicitud
        this.requestService.incrementRequests();

        return next.handle(req).pipe(
            finalize(() => {
                // Disminuye el contador cuando la solicitud se ha completado
                this.requestService.decrementRequests();
            })
        );
    }
}
